module.exports = __webpack_public_path__ + "static/campaign-progress-4d8c889e566d70b626c6413041af092d.jpg";